import TradeHub from '../components/trade/TradeHub';

export default [
  {
    name: 'TradeHub',
    path: '/trade',
    component: TradeHub,
  },
]
